
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/opleidingen/[uid]/reviews",
      function () {
        return require("private-next-pages/opleidingen/[uid]/reviews/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/opleidingen/[uid]/reviews"])
      });
    }
  